<section class="data-table w-100">
    <header class="data-table__header">
        <h2 class="page-heading tab-content-header active" id="products-content-header">
            <ng-container i18n="@@products.addons">Addons</ng-container>
        </h2>
        <div class="d-flex">
            <button  class="d-flex add_new_invoice_btn mr-2" (click)="openModal()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 5V19M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
                <ng-container i18n="@@products.add_addons">Add Addons</ng-container>
            </button>
            <button  class="d-flex add_new_invoice_btn mr-2" (click)="backToProduct()">
                <ng-container i18n="@@products.add_new_product">Product</ng-container>
            </button>
        </div>
    </header>

    <div class="data-table__wrap mt-4">
        <div class="table-wrapper">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th i18n="@@addons.name_english">Name (English)</th>
                        <th i18n="@@addons.name_arabic">Name (Arabic)</th>
                        <th i18n="@@addons.options">Options</th>
                        <th i18n="@@orders.actions">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let modifier of modifiers">
                        <td>{{ modifier.name }}</td>
                        <td>{{ modifier.name_ar }}</td>
                        <td>
                            <span *ngFor="let opt of modifier.modifier_options">{{ opt.name }} <span *ngIf="opt.name_ar">({{opt.name_ar}})</span>, </span>
                        </td>
                        <td class="text-center">
                            <div _ngcontent-mna-c284="" class="d-flex flex-row gap-2 align-center">
                                <svg _ngcontent-mna-c284="" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                    viewBox="0 0 20 20" fill="none" (click)="openModal(modifier)">
                                    <path _ngcontent-mna-c284=""
                                        d="M15.0002 8.33326L11.6669 4.99993M2.0835 17.9166L4.9038 17.6032C5.24838 17.5649 5.42067 17.5458 5.5817 17.4937C5.72457 17.4474 5.86054 17.3821 5.9859 17.2994C6.12721 17.2062 6.24978 17.0836 6.49493 16.8385L17.5002 5.83326C18.4207 4.91279 18.4207 3.4204 17.5002 2.49993C16.5797 1.57945 15.0873 1.57945 14.1669 2.49992L3.1616 13.5052C2.91645 13.7503 2.79388 13.8729 2.70069 14.0142C2.61802 14.1396 2.55268 14.2755 2.50642 14.4184C2.45429 14.5794 2.43515 14.7517 2.39686 15.0963L2.0835 17.9166Z"
                                        stroke="#646464" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                </svg>
                                <svg _ngcontent-mna-c284="" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                    viewBox="0 0 20 20" fill="none" (click)="onDelete(modifier.id)">
                                    <path _ngcontent-mna-c284=""
                                        d="M13.3333 4.99984V4.33317C13.3333 3.39975 13.3333 2.93304 13.1517 2.57652C12.9919 2.26292 12.7369 2.00795 12.4233 1.84816C12.0668 1.6665 11.6001 1.6665 10.6667 1.6665H9.33333C8.39991 1.6665 7.9332 1.6665 7.57668 1.84816C7.26308 2.00795 7.00811 2.26292 6.84832 2.57652C6.66667 2.93304 6.66667 3.39975 6.66667 4.33317V4.99984M2.5 4.99984H17.5M15.8333 4.99984V14.3332C15.8333 15.7333 15.8333 16.4334 15.5608 16.9681C15.3212 17.4386 14.9387 17.821 14.4683 18.0607C13.9335 18.3332 13.2335 18.3332 11.8333 18.3332H8.16667C6.76654 18.3332 6.06647 18.3332 5.53169 18.0607C5.06129 17.821 4.67883 17.4386 4.43915 16.9681C4.16667 16.4334 4.16667 15.7333 4.16667 14.3332V4.99984"
                                        stroke="#EB1461" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                </svg>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="modifiers.length === 0">
                        <td colspan="3" class="text-center" i18n="@@report.no_data">No data found.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>

<ng-template #modifierModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" *ngIf="!editMode" i18n="@@addons.add_addons">Add Addons</h4>
        <h4 class="modal-title" *ngIf="editMode" i18n="@@addons.edit_addons">Edit Addons</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="modifierForm" (ngSubmit)="onSave(modal)">
        <div class="modal-body">
            <div class="d-flex align-items-center">
                <div class="form-group me-2 w-100">
                    <label i18n="@@addons.modifier_name_english">Addons Name (English)</label><span class="required-star">*</span>
                    <input class="form-control" formControlName="name" />
                    <div *ngIf="modifierForm.get('name').invalid && modifierForm.get('name').touched">
                        <small class='text-danger' i18n="@@addons.add">Name is required</small>
                    </div>
                </div>
                <div class="form-group w-100 pt-3px">
                    <label i18n="@@addons.modifier_name_arabic">Addons Name (Arabic)</label><span class="required-star"></span>
                    <input class="form-control" formControlName="name_ar" />
                </div>
            </div>
            <div class="form-group d-flex align-items-center justify-content-between">
                <label i18n="@@addons.modifier_options">Addons Options</label>
                <button class="tu-btn pink" type="button" (click)="addOption()" i18n="@@addons.add">Add</button>
            </div>
            <div formArrayName="modifier_options">
                <div *ngFor="let opt of modifier_options.controls; let i = index" [formGroupName]="i" class="form-group d-flex align-items-center">
                    <span class="mt-2 me-2">
                        <label i18n="@@addons.name_english">Name (English)</label><span class="required-star mr-2 mb-2">*</span>
                        <input type="text" class="form-control mr-3" formControlName="name" />
                        <div *ngIf="opt.get('name').invalid && opt.get('name').touched">
                            <small class="text-danger" i18n="@@addons.name_required">Option name is required</small>
                        </div>
                    </span>
                    <span class="mt-2 me-2 pt-3px">
                        <label i18n="@@addons.name_arabic">Name (Arabic)</label><span class="required-star mr-2 mb-2"></span>
                        <input type="text" class="form-control mr-3" formControlName="name_ar" />
                    </span>
                    <span class="mt-2">
                        <label class="ml-1" i18n="@@addons.price">Price</label><span class="required-star mr-2 mb-2">*</span>
                        <input type="number" class="form-control mr-3" formControlName="price" />
                        <div *ngIf="opt.get('price').invalid && opt.get('price').touched">
                            <small class="text-danger" i18n="@@addons.price_required">Price is required and must be 0 or more</small>
                        </div>
                    </span>
                    
                    <span class="mt-2">
                        <button type="button" class="btn-outline-danger btn-sm" (click)="removeOption(i)" i18n="@@addons.remove">Remove</button>
                    </span>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="tu-btn pink m-1" type="submit" i18n="@@users.save">Save</button>
            <button class="tu-btn transparent blue" type="button" (click)="modal.dismiss('Cancel')" i18n="@@ts.common.cancel">Cancel</button>
        </div>
    </form>
</ng-template>